/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 21H17M12 21H7M12 21V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6M12 3H17.6C18.4401 3 18.8601 3 19.181 3.16349C19.4632 3.3073 19.6927 3.53677 19.8365 3.81901C20 4.13988 20 4.55992 20 5.4V5.5V6M12 3V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M12 3V21M12 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6M12 3H17.6C18.4401 3 18.8601 3 19.181 3.16349C19.4632 3.3073 19.6927 3.53677 19.8365 3.81901C20 4.13988 20 4.55992 20 5.4V5.5V6M12 21H17M12 21H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12 3V21M12 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6M12 3H17.6C18.4401 3 18.8601 3 19.181 3.16349C19.4632 3.3073 19.6927 3.53677 19.8365 3.81901C20 4.13988 20 4.55992 20 5.4V5.5V6M12 21H17M12 21H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 21H17M12 21H7M12 21V6.5M20 6V5.5V5.4C20 4.55992 20 4.13988 19.8365 3.81901C19.6927 3.53677 19.4632 3.3073 19.181 3.16349C18.8601 3 18.4401 3 17.6 3H12H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 3V21M12 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6M12 3H17.6C18.4401 3 18.8601 3 19.181 3.16349C19.4632 3.3073 19.6927 3.53677 19.8365 3.81901C20 4.13988 20 4.55992 20 5.4V5.5V6M12 21H17M12 21H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M12 3V21M12 3H6.4C5.55992 3 5.13988 3 4.81901 3.16349C4.53677 3.3073 4.3073 3.53677 4.16349 3.81901C4 4.13988 4 4.55992 4 5.4V5.5V6M12 3H17.6C18.4401 3 18.8601 3 19.181 3.16349C19.4632 3.3073 19.6927 3.53677 19.8365 3.81901C20 4.13988 20 4.55992 20 5.4V5.5V6M12 21H17M12 21H7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
